const STATUS_PERSETUJUAN = {
  0: "Ditolak",
  1: "Disetujui",
  2: "Pending",
};

const STATUS_REVISI = {
  Ditolak: 0,
  Disetujui: 1,
  "Menunggu revisi mahasiswa": 2,
  "Menunggu evaluasi dosen": 3,
};

const STATUS_REVISI_PARSE = {
  Ditolak: "Ditolak",
  Disetujui: "Disetujui",
  "Menunggu revisi mahasiswa": "Menunggu revisi mahasiswa",
  "Menunggu evaluasi dosen": "Menunggu evaluasi dosen",
};

const STATUS_REVISI_FORM = {
  Ditolak: 0,
  Disetujui: 1,
};

export {
  STATUS_PERSETUJUAN,
  STATUS_REVISI,
  STATUS_REVISI_PARSE,
  STATUS_REVISI_FORM,
};
